import useGsapContext from '../../hooks/UseGsapContext';
import gsap from 'gsap';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import useScrollBlock from 'src/app/hooks/useScrollBlock';
import { useSelector, useDispatch } from 'react-redux';
import { selectScene, selectLang } from '../../redux/slice/sceneSlice';

const logos = require.context('../../../assets/logos');

const AppMenu = ({ data }) => {
  // STATES
  const [logo, setLogo] = useState('./eng-logo-white.png');
  const newCurrentScene = useSelector(
    (state) => state.sceneController.newCurrentScene
  );
  const lang = useSelector((state) => state.sceneController.lang);

  const dispatch = useDispatch();
  // Hooks blockscroll
  const [blockScroll, allowScroll] = useScrollBlock();
  // Ref's
  const menu = useRef();
  const mobileMenu = useRef();

  const ctx = useGsapContext(menu);
  // Open menu
  const openMenu = () => {
    gsap.to(mobileMenu.current, {
      keyframes: {
        x: [-window.innerWidth, 0],
        opacity: [0, 1],
      },
    });

    setTimeout(blockScroll(), 1000);
  };
  // Close menu
  const closeMenu = () => {
    gsap.to(mobileMenu.current, {
      keyframes: {
        x: [0, -window.innerWidth],
        opacity: [1, 0],
      },
    });
    setTimeout(allowScroll(), 1000);
  };
  // Select scenes
  const changeScene = (target, mobile) => {
    if (newCurrentScene !== target) {
      allowScroll();
      dispatch(selectScene(target));
      mobile && closeMenu();
    }
  };
  // Select Lang
  const changeLang = (lg) => {
    allowScroll();
    dispatch(selectLang(lg));
  };
  // Init GSAP
  useLayoutEffect(() => {
    ctx.add(() => {
      gsap.set(mobileMenu.current, { x: -window.innerWidth, opacity: 0 });
    }, menu);
    return () => ctx.revert();
  });

  useEffect(() => {
    if (lang == 'ESP') {
      (newCurrentScene - 1) % 2
        ? setLogo('./esp-logo-black.png')
        : setLogo('./esp-logo-white.png');
    }
    if (lang == 'ENG') {
      (newCurrentScene - 1) % 2
        ? setLogo('./eng-logo-black.png')
        : setLogo('./eng-logo-white.png');
    }
  }, [lang, newCurrentScene]);

  return (
    <header
      className={
        (newCurrentScene - 1) % 2
          ? 'app-menu dark-mode dark-mode-menu'
          : 'app-menu'
      }
      ref={menu}
    >
      <a href={data.logo.dir} className="app-menu-logo">
        <img
          className=""
          width="181px"
          height={'auto'}
          data-depth={'0.18'}
          src={logos(logo)}
          alt={data.logo.alt}
        />
      </a>
      <nav className="desktop-menu">
        <ol className={'options'}>
          <li aria-hidden="true">
            <a
              href={data?.redirect}
              aria-label={
                lang == 'ESP'
                  ? 'Ir a la web de alliancebioversityciat.com'
                  : 'Go to alliancebioversityciat.com'
              }
            >
              <i className="icons-ciat icon-home" />
            </a>
          </li>
          <li>
            <button
              aria-label={
                lang == 'ESP'
                  ? 'Cambiar idioma a Ingles'
                  : 'Change language to spanish'
              }
              className="option-btn"
              onClick={() =>
                lang !== 'ESP' ? changeLang('ESP') : changeLang('ENG')
              }
            >
              <p className={lang == 'ENG' ? 'active' : ''}>{data?.langs[1]}</p>
              <p aria-hidden="true">/</p>
              <p className={lang == 'ESP' ? 'active' : ''}>{data?.langs[0]}</p>
            </button>
          </li>
        </ol>
        <ol
          className={
            newCurrentScene === '01'
              ? 'desktop-picker-hidden'
              : 'desktop-picker'
          }
        >
          {data?.scenes?.map((item, index) => (
            <li key={index}>
              <button
                className={`${index == 0 ? 'btn-intro' : 'btn-generic'} ${
                  newCurrentScene == item?.scene
                    ? index == 0
                      ? 'active-intro'
                      : 'active-generic'
                    : ''
                }`}
                onClick={() => changeScene(item?.scene)}
              >
                <p>{item?.title}</p>
                <p>{item?.date}</p>
              </button>
            </li>
          ))}
        </ol>
      </nav>
      <button
        className={'mobile-button'}
        onClick={() => openMenu()}
        aria-label={lang !== 'ESP' ? 'Abrir menu' : 'Open menu'}
      >
        <i className="icons-ciat icon-mobile-menu"></i>
      </button>

      <nav className={`mobile-menu`} ref={mobileMenu}>
        <div className="mobile-container">
          <ol className="mobile-options">
            <li
              className="mobile-options-close"
              aria-label={lang == 'ESP' ? 'Cerrar menú' : 'Close menu'}
            >
              <button onClick={() => closeMenu()}>
                <i className="icons-ciat icon-close" />
              </button>
            </li>
            <li aria-hidden="true">
              <a
                href="https://alliancebioversityciat.org/es"
                aria-label={
                  lang == 'ESP'
                    ? 'Ir a la web de alliancebioversityciat.com'
                    : 'Go to alliancebioversityciat.com'
                }
              >
                <i className="icons-ciat icon-home" />
              </a>
            </li>
            <li className={lang == 'ESP' ? 'active' : ''}>
              <button
                aria-label={
                  lang == 'ESP'
                    ? 'Cambiar idioma a Ingles'
                    : 'Change language to spanish'
                }
                onClick={() =>
                  lang !== 'ESP' ? changeLang('ESP') : changeLang('ENG')
                }
              >
                <p className={lang == 'ENG' ? 'active' : ''}>
                  {data?.langs[1]}
                </p>
                <p aria-hidden="true">/</p>
                <p className={lang == 'ESP' ? 'active' : ''}>
                  {data?.langs[0]}
                </p>
              </button>
            </li>
          </ol>
          <ol className="mobile-scene-picker">
            {data?.scenes?.map((item, index) => (
              <li key={index}>
                <button onClick={() => changeScene(item?.scene, true)}>
                  <p className={newCurrentScene == item?.scene ? 'active' : ''}>
                    {item?.title}
                  </p>
                  <p
                    className={
                      newCurrentScene == item?.scene && newCurrentScene === '01'
                        ? 'active'
                        : ''
                    }
                  >
                    {item?.date}
                  </p>
                </button>
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </header>
  );
};

export default AppMenu;
